import React from "react"
import { CheckCircle2, Flag } from "lucide-react"
import type { AttemptConfidence } from "../../Questions/types"
import "./ConfidenceBadge.style.scss"

interface ConfidenceBadgeProps {
  confidence: AttemptConfidence | null
}

const ConfidenceBadge = ({ confidence }: ConfidenceBadgeProps) => {
  if (!confidence) return null
  if (confidence === "high") {
    return (
      <span className="confidence-badge is-high">
        <CheckCircle2 size={12} /> High Confidence
      </span>
    )
  }
  if (confidence === "medium") {
    return (
      <span className="confidence-badge is-medium">
        <CheckCircle2 size={12} /> Medium Confidence
      </span>
    )
  }
  return (
    <span className="confidence-badge is-low">
      <Flag size={12} /> Flagged for Review
    </span>
  )
}

export default ConfidenceBadge
